module["exports"] = [
  "#{street_root}"
];
